import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  // Continue button label
  continueApplicationLabel: {
    id: "funding-application: continue application button label",
    defaultMessage: "Continue",
  },

  // Platform selection validation errors
  missingRevenueMarketingAndAccounting: {
    id: "funding-application: missing revenue marketing and accounting error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please add accounting data, and connect a marketing and online sales platform.",
  },
  missingRevenueAndAccounting: {
    id: "funding-application: missing revenue platform and accounting data error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please add accounting data and connect an online sales platform.",
  },
  missingRevenueAndMarketing: {
    id: "funding-application: missing revenue and marketing platforms error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please connect a marketing and online sales platform.",
  },
  missingMarketingAndAccounting: {
    id: "funding-application: missing marketing and accounting error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please add accounting data and connect a marketing platform.",
  },
  missingRevenuePlatform: {
    id: "funding-application: missing revenue platform error",
    defaultMessage: "You must add an online sales platform that will give us visibility into your sales performance.",
  },
  missingMarketingPlatform: {
    id: "funding-application: missing marketing platform error",
    defaultMessage: "You must add a marketing platform in order for us to fully assess your eligibility for funding.",
  },
  missingAccountingData: {
    id: "funding-application: missing accounting data error",
    defaultMessage: "You must add accounting data in order for us to fully assess your eligibility for funding.",
  },

  // Platform not listed modal
  platformNotListedCardLabel: {
    id: "funding-application: platform not listed card label",
    defaultMessage: "My platform isn't listed",
  },
  platformNotListedModalTitle: {
    id: "funding-application: platform not listed modal title",
    defaultMessage: "Are you sure your platform isn't listed?",
  },
  platformNotListedModalDescription: {
    id: "funding-application: platform not listed modal description",
    defaultMessage:
      "You can apply without a listed platform. If you have one of the platforms shown, we'll need to connect it to process your application. Skipping this step means we'll request it later, which will delay your application.",
  },
});
